import './index.less'
import { customerInfo, customerJoin, customerPhone, customerResult, customerPopData, shopCR, checkRobot } from '@utils/fetch.js'
import { isMobile, cookie, copyString, verifyEmail, shopGetParam, isiOS, DragToMove, setContentWidth, resetContentWidth, } from '@utils/index.js'
import { formatMoney } from '@shopify/theme-currency'

class NewCustomerPop {
  constructor({ initShow = false, }) {
    // 初始时是否显示，兼容处理
    this.initShow = initShow

    this.customerPopTimer = null;
    this.customerParams = {};

    this.joinStatus = false; // 防止频繁点击触发接口
    this.customer_result = {};
    this.join_params = {};

    this.customerObj = localStorage.getItem('customerObj') || {}
    this.customerStatus = sessionStorage.getItem('customerStatus') || false

    // 券码包 DOM 节点
    this.couponPkgWrapDOM = document.querySelector('[data-coupon-pkg-wrap]')
    this.couponPkgListWrapDOM = document.querySelector('[data-coupon-pkg-list-wrap]')

    this.init()
  }

  // 数据埋码
  NewCustomerGAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"popup_newcomer_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    });
  }

  // 券包数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"popup_coupon_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    });
  }

  // 初始化弹框内容
  initCustomerData() {
    $('.J-newCustomer-one .title').text(this.customerParams.main_title).css('color', this.customerParams.main_title_color)
    $('.J-newCustomer-one .subtitle').text(this.customerParams.sub_title).css('color', this.customerParams.sub_title_color)

    if (this.backgroundMode === 'small') {
      $('.J-newCustomer-one .gift-box').css('visibility', 'visible')

      if (isMobile() && window.screen.width <= 768) {
        $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.web_main_banner_url)
        // loading 图片
        $('.J-newCustomer-gift img').attr('src', this.customerParams.loading_url_web || '')
      } else {
        $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.pc_main_banner_url)
        // loading 图片
        $('.J-newCustomer-gift img').attr('src', this.customerParams.loading_url || '')
      }
    }else {
      $('.J-newCustomer-one .gift-box').css('visibility', 'hidden')
      $('.J-newCustomer-one .gift-box img').remove()

      if (isMobile() && window.screen.width <= 768) {
        $('.new-customer-box').css('background', `white url(${this.customerParams.web_full_main_banner_url}) center center /cover no-repeat`)
        // loading 图片
        $('.J-newCustomer-gift img').attr('src', this.customerParams.loading_url_web || '')
      } else {
        $('.new-customer-box').css('background', `white url(${this.customerParams.pc_full_main_banner_url}) center center /cover no-repeat`)
        // loading 图片
        $('.J-newCustomer-gift img').attr('src', this.customerParams.loading_url || '')
      }
    }

    // 自定义颜色
    $('.J-newCustomer-one .J-newCustomer-email').attr('placeholder', this.customerParams.email_desc)
    const root = document.querySelector(':root')
    root.style.setProperty('--new-customer-email-placeholder-color', this.customerParams.email_color)
    root.style.setProperty('--new-customer-privacy-policy-color', this.customerParams.privacy_policy_color)

    // 额外说明
    $('.J-newCustomer-one .extra-description').text(this.customerParams.privacy_purposes_text).css('color', this.customerParams.privacy_purposes_text_color)

    $('.J-newCustomer-two .title').text(this.customerParams.wait_main_title || this.customerParams.main_title).css('color', this.customerParams.wait_main_title_color)
    $('.J-newCustomer-two .subtitle').text(this.customerParams.wait_sub_title).css('color', this.customerParams.wait_sub_title_color)
  }

  init() {
    let self = this
    // 先调接口获取活动信息
    customerInfo({ url: window.location.href || '' }).then((r) => {
      let res = r.data
      this.customerParams = res
      if (res?.act_display) {
        $('.J-customer-plugin').show()
        this.backgroundMode = res.background_mode || 'small'

        // 图片预加载
        if(this.backgroundMode === 'small') {
          this.preloader(res.pc_main_banner_url)
          this.preloader(res.web_main_banner_url)
        }else {
          this.preloader(res.pc_full_main_banner_url)
          this.preloader(res.web_full_main_banner_url)
        }

        res.float_icon_url && this.preloader(res.float_icon_url)
        res.loading_url && this.preloader(res.loading_url)
        res.loading_url_web && this.preloader(res.loading_url_web)

        // 判断是否自动弹框
        if (res.auto_popup) {
          // show_type 活动展示类型，0：每个访客x次，1：每个访客每次访问都弹出。2：每隔X次弹出，3：在时间段内弹出一次， 4：在第X次访问弹出
          let data = JSON.parse(localStorage.getItem('customerObj'))

          // 判断是否修改了活动类型,若修改了活动类型则重置访问次数
          // union_token,表示新周期的活动
          if (data.show_type !== this.customerParams.show_type || data.union_token !== this.customerParams.union_token) {
            data.union_token = this.customerParams.union_token
            data.show_type = this.customerParams.show_type
            data.customer_number = 1
            data.show_status_0 = 'yes'
            data.show_status_2 = 'yes'
            data.show_status_3 = 'yes'
          }

          // 每个访客x次
          if (this.customerParams.show_type === 0 && sessionStorage.getItem('show_status_0') !== 'no') {
            if (+this.customerParams.show_type_value === 0) {
              data.show_status_0 = 'no'
            } else if (+this.customerParams.show_type_value > 0) {
              if (data.customer_number > +this.customerParams.show_type_value) {
                data.show_status_0 = 'no'
              } else {
                data.show_status_0 = 'yes'
              }
            }
          } else {
            data.show_status_0 = 'no'
          }

          // 每隔X次弹出
          if (sessionStorage.getItem('show_status_2') !== 'no') {
            if (+this.customerParams.show_type_value === 0) {
              data.show_status_2 = 'yes'
            } else if (+this.customerParams.show_type_value > 0) {
              if (data.customer_number === 1) {
                data.show_status_2 = 'yes'
              } else if (+this.customerParams.show_type_value + 1 === data.customer_number - data.last_open) {
                data.show_status_2 = 'yes'
              }
            }
          }

          // 在时间段内弹出一次
          if (data.currentTime) {
            data.show_status_3 = this.customerParams.server_timer - data.currentTime >= this.customerParams.show_type_value ? 'yes' : 'no'
          }

          if (this.customerParams.show_type === 0 && data.show_status_0 !== 'no') {
            this.customerPopShow(res)
            sessionStorage.setItem('show_status_0', 'no')
          } else if (this.customerParams.show_type === 1) {
            this.customerPopShow(res)
          } else if (this.customerParams.show_type === 2 && data.show_status_2 !== 'no') {
            this.customerPopShow(res)
            data.show_status_2 = 'no'
            data.last_open = data.customer_number
            sessionStorage.setItem('show_status_2', 'no') // customer_number未变，则需要控制弹框不再展示
          } else if (this.customerParams.show_type === 3 && data.show_status_3 !== 'no') {
            this.customerPopShow(res)
            data.show_status_3 = 'no'
            data.currentTime = this.customerParams.server_timer
          } else if (this.customerParams.show_type === 4 && data.customer_number === Number(this.customerParams.show_type_value)) {
            this.customerPopShow(res)
          }
          localStorage.setItem('customerObj', JSON.stringify(data))
        } else {
          clearTimeout(this.customerPopTimer)
        }

        // 判断是否显示左下角悬浮图标
        let customerIconHide = cookie.get('customerIconHide')
        if (res.show_float_window && res.float_icon_url && customerIconHide != 'hide') {
          // icon 拖拽
          new DragToMove({
            el: '.J-newCustomer-button',
            placement: 'left', // 目标位置，'left' - 靠左，'right' - 靠右
            offset: { // 偏移量
                x: 20,
                y: '10%',
            },
            onClick: () => this.iconClick(),
            closable: true,
            closableEl: '#icon-close',
            closedCallback: (e) => {
              e?.stopPropagation()
              e.cancelBubble = true

              $('.J-newCustomer-button').hide()
              $('#new-customer-pop').removeClass("active").fadeOut()
              // 恢复 内容区域 宽度
              resetContentWidth()

              let date = new Date()
              date.setTime(date.getTime() + (24 * 60 * 60 * 1000))
              document.cookie = `customerIconHide=hide; expires=${date.toGMTString()}; path=/;`
            }
          })

          // icon 链接
          $('.J-newCustomer-button .icon-img').attr('data-src', res.float_icon_url)

          // icon 位置
          if (res.float_icon_buttom) {
            const suit = res.float_icon_scope
            const bottom = res.float_icon_buttom
            if (suit === 0) {
              // 仅移动端
              if (isMobile() && window.screen.width <= 768) {
                $('.J-newCustomer-button').css('bottom', bottom)
              }
            } else if (suit === 1) {
              // 仅PC端
              if (!isMobile() && window.screen.width > 768) {
                $('.J-newCustomer-button').css('bottom', bottom)
              }
            } else {
              // 两者都有
              $('.J-newCustomer-button').css('bottom', bottom)
            }
          }
          this.initShow && $('.J-newCustomer-button').show()
        } else {
          $('.J-newCustomer-button').hide()
        }

        // 判断是否配置了虚拟礼品卡，配置了就加载防刷js
        if (res.has_virtual_coupon_item) {
          let script = document.createElement('script')
          script.src = 'https://www.google.com/recaptcha/enterprise.js?onload=laxinOnloadCallback&render=explicit&hl=en'
          script.defer = true
          document.head.appendChild(script)
        }

        // 拉新功能启用后，11周年活动页 拉新版块 按钮触发事件生效
        const $anniversaryGifts = $('.anniversary-gifts-component')
        if($anniversaryGifts){
          $('.anniversary-gifts-box .btn-gift').click(() => this.iconClick())
        }
      } else {
        $('.J-customer-plugin').hide()
        localStorage.removeItem('customerObj')
      }
    })

    // 关闭弹框
    $('.J-newCustomer-close').click(function () {
      $('#new-customer-pop').removeClass("active").fadeOut()
      // 恢复 内容区域 宽度
      resetContentWidth()

      const step = $(this).attr('customer-current-step')
      if (step === 'one') {
        self.getCustomerPopup('popup_home_close')
      } else if (step === 'two') {
        self.getCustomerPopup('popup_two_close')
      } else if (step === 'three-result') {
        // 上报数据
        if (!self.couponPkgWrapDOM.classList.contains('display-none')) {
          self.getCustomerPopup('coupon_package_btn_close')
        } else {
          self.getCustomerPopup('result_close')
        }

        // 数据埋码
        let title = 'No.3 PoPup'
        const siblingsDOM = $('.J-newCustomer-close').siblings()
        $.each(siblingsDOM, (i, it) => {
          if (!it.classList.contains('display-none')) {
            title = it.querySelector('.title').innerText
          }
        })

        self.GAEvent({
          module: title,
          button_name: 'close',
          link: null,
        })
      } else if (step === 'three-phone') {
        self.getCustomerPopup('phone_close')
      } else if (step === 'three-register') {
        self.getCustomerPopup('reg_close')
      }
    })

    // 点击提交邮箱按钮参与活动
    $('.J-newCustomer-submit').click((e) => this.newCustomerSubmit(e))

    // 输入框交互
    $('.J-newCustomer-email').focus(() => this.emailFocus())

    // 奖品展示按钮
    $('.J-newCustomer-left').click(() => this.newCustomerLeftClick())
    $('.J-newCustomer-right').click(() => this.newCustomerRightClick())

    // 点击code复制
    $('.J-newCustomer-code').click(e => this.newCustomerCodeClick(e))

    // 点击提交电话号
    $('.J-newCustomer-phoneSubmit').click(() => this.newCustomerPhoneSubmitClick())


    // 处理 more 移入显示 tooltip
    $('body').on('mouseenter', '.J-newCustomer-coupon-text .more', function() {
      $(this).parent().parent().siblings('.toolTip').fadeIn()
    })
    $('body').on('mouseleave', '.J-newCustomer-coupon-text .toolTip', function() {
      $(this).fadeOut()
    })
    $('body').on('mouseenter', '.J-newCustomer-virtual-explain .more, .J-newCustomer-joined-virtualExplain .more', function() {
      $(this).parent().parent().siblings('.toolTip').fadeIn()
    })
    $('body').on('mouseleave', '.J-newCustomer-virtual-explain .toolTip, .J-newCustomer-joined-virtualExplain .toolTip', function() {
      $(this).fadeOut()
    })


    // 处理注册or激活完成后落地页展示奖品
    if (location.pathname === '/' && shopGetParam("newCustomerTask")) {
      let pageCustomerTask = localStorage.getItem('pageCustomerTask')
      if (pageCustomerTask === 'completed') {
        $('.J-newCustomer-one').removeClass('display-none')
        $('.J-newCustomer-three').addClass('display-none')
        $('.J-newCustomer-joined').addClass('display-none')
      } else {
        // 落地页先去掉自动弹出逻辑，根据接口返回是否完成任务再判断是否需要弹出
        clearTimeout(this.customerPopTimer)
        $('#new-customer-pop').removeClass("active").fadeOut()
        // 恢复 内容区域 宽度
        resetContentWidth()

        let params = {
          join_token: shopGetParam("join_token"),
          email: shopGetParam("email")
        }
        customerResult(params).then((r) => {
          let res = r.data
          if (res.status === 1) {
            this.customer_result = res
            $('.J-newCustomer-one').addClass('display-none')
            $('.J-newCustomer-three').removeClass('display-none')

            this.customerPrizesShow()

            $('#new-customer-pop').fadeIn().delay(300).addClass("active")

            // 设置 内容区域 宽度，防止 页面闪烁
            setContentWidth()
          }
          localStorage.setItem('pageCustomerTask', 'completed')
        })
      }
    } else {
      localStorage.removeItem('pageCustomerTask')
    }

    // 记录访问次数-页签打开到页签关闭为 1 次
    if (JSON.stringify(this.customerObj) === '{}') {
      let obj = {
        customer_number: 1
      }
      localStorage.setItem('customerObj', JSON.stringify(obj))
      sessionStorage.setItem('customerStatus', true)
    } else {
      let data = JSON.parse(this.customerObj)
      if (!this.customerStatus) {
        data.customer_number++
        localStorage.setItem('customerObj', JSON.stringify(data))
        sessionStorage.setItem('customerStatus', true)
      }
    }

    // 人机验证
    window.laxinOnloadCallback = () => {
      if (!window.recaptchaRendered) {
        const grecaptchaID = grecaptcha.enterprise.render('new-customer-robot', {
          'sitekey': '6LdR6NEmAAAAAAff5hHDghPULuJaGBYG1llLA74L',
          'callback': (val) => {
            console.log('验证成功');
            let obj = {
              token: val, // 令牌
              join_token: this.join_params.join_token,
              email: this.join_params.email,
            }
            checkRobot(obj).then(res => {
              console.log(res,'后台校验通过');
              let obj = {
                join_token: this.join_params.join_token,
                email: this.join_params.email,
                // source_url: encodeURIComponent(window.location.href),
              }
              this.getPrizesInfo(obj)
            }).catch(err => {
              console.log(err, '后台校验未通过');
              grecaptcha.enterprise.reset(grecaptchaID)
            })
          }
        })

        window.recaptchaRendered = true
      }
    }
  }

  // 点击悬浮按钮打开弹框
  iconClick() {
    // 如果 没有值
    if (Object.keys(this.customerParams).length === 0) {
      return
    }

    $('#new-customer-pop').fadeIn().delay(300).addClass("active")
    this.initCustomerData()
    this.getCustomerPopup('popup_home')

    // 设置 内容区域 宽度，防止 页面闪烁
    setContentWidth()

    if (
      !$('.J-newCustomer-two').hasClass('display-none') ||
      !$('.J-newCustomer-three').hasClass('display-none') ||
      !this.couponPkgWrapDOM.classList.contains('display-none') ||
      ($('.J-customer-recaptcha').length && !$('.J-customer-recaptcha').hasClass('display-none')) ||
      !$('.J-newCustomer-joined').hasClass('display-none')
    ) {
      $('.new-customer-box').css('background', 'white')
    }
  }

  // 点击提交邮箱按钮参与活动
  newCustomerSubmit(e) {
    const emailVal = $('.J-newCustomer-email').val()
    const checkboxVal = $('.J-newCustomer-checkbox input').is(':checked')

    // 校验
    $('.J-newCustomer-tip').hide()
    $('.J-newCustomer-checkbox').removeClass('error')
    emailVal === ''
      ? $('.J-newCustomer-tip').fadeIn().text($('.J-newCustomer-tip').data('email-tip'))
      : !verifyEmail(emailVal)
        ? $('.J-newCustomer-tip').fadeIn().text($('.J-newCustomer-tip').data('emailerror-tip'))
        : !checkboxVal
          ? $('.J-newCustomer-checkbox').addClass('error')
          : ''

    if ($('.J-newCustomer-checkbox').hasClass('error')) {
      return false
    }

    if ($('.J-newCustomer-tip').is(':hidden')) {
      this.getCustomerPopup('join')
      const params = {
        email: emailVal,
        act_id: this.customerParams.act_id,
        union_id: cookie.get("_shopify_y"),
        source_url: encodeURIComponent(window.location.href),
      }
      if (!this.joinStatus) {
        this.joinStatus = true
        e.target.classList.add('btn--loading')
        customerJoin(params).then((r) => {
          let res = r.data;
          $('.J-newCustomer-one').addClass('display-none')
          $('.new-customer-box').css('background', 'white')
          $('.J-newCustomer-close').attr('customer-current-step', 'two')
          $('.J-newCustomer-two').removeClass('display-none')

          // setTimeout(() => {
            this.getPrizesInfo({
              join_token: res.join_token,
              email: emailVal,
              // source_url: encodeURIComponent(window.location.href),
            })
          // }, 100)
        }).catch((err) => {
          if (err.code === 62003) {
            // 重复参与活动
            this.getPrizesInfo({
              join_token: err.data.join_token,
              email: emailVal,
              // source_url: encodeURIComponent(window.location.href),
            }, 'repeat')
          } else {
            $('.J-newCustomer-tip').fadeIn().text(err.message)
            if (this.backgroundMode === 'small') {
              if (isMobile() && window.screen.width <= 768) {
                $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.web_main_banner_url)
              } else {
                $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.pc_main_banner_url)
              }
            }else {
              if (isMobile() && window.screen.width <= 768) {
                $('.new-customer-box').css('background', `white url(${this.customerParams.web_full_main_banner_url}) center center /cover no-repeat`)
              } else {
                $('.new-customer-box').css('background', `white url(${this.customerParams.pc_full_main_banner_url}) center center /cover no-repeat`)
              }
            }
          }
        }).finally(() => {
          this.joinStatus = false
          e.target.classList.remove('btn--loading')
        })
      }
    } else {
      isMobile() ? $('.J-newCustomer-email').addClass('shake-bottom') : $('.J-newCustomer-form').addClass('shake-bottom')
    }
  }

  // 获取奖品信息
  getPrizesInfo(obj, status) {
    this.join_params = obj
    customerResult(obj).then((r) => {

      let res = r.data
      this.customer_result = res
      if (status === 'repeat') {
        // 数据上报
        $('.J-newCustomer-close').attr('customer-current-step', 'joined')

        // 虚拟奖品 特殊处理
        if (res.welfate_type === 3) {
          this.handleRepeat(res)

          if (res.reward_rules?.length) {
            const str =
              res.reward_rules
                .filter(it => it !== '')
                .reduce((p, n) => p += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`, '')
            $('.J-newCustomer-joined-virtualText').removeClass('display-none').html(str)
          }
          if (res.explain_desc?.length) {
            const str =
              res.explain_desc
                .filter(it => it !== '')
                .reduce((p, n) => p += `<div>${n}</div>`, '')
            $('.J-newCustomer-joined-virtualExplain').removeClass('display-none').html(str)
          }
        }
        // 虚拟礼品卡
        else if (res.welfate_type === 5) {
          this.handleRepeat(res)
          // 处理 虚拟礼品卡 规则
          this.handleVirtualRules(res, 'explain')
        }
        //券码包内容
        else if (res.welfate_type === 10) {
          this.handleCouponPkg(res)
        }
        else {
          this.handleRepeat(res)

          $('.J-newCustomer-coupon-text').removeClass('display-none')
          $('.J-newCustomer-limit').text(formatMoney(res.expand_field.limit_amount * 100, window.pageInfo.currency.money_format))

          if (res.expand_field.limit_amount == 0) {
            $('.J-newCustomer-limit').parent().addClass('display-none').siblings().removeClass('display-none')
          }
          // 如果有有效期截止时间，则显示有效期，否则不显示
          if (res.expand_field.end_at_desc) {
            $('.J-newCustomer-time').text(res.expand_field.start_at_desc + ' ~ ' + res.expand_field.end_at_desc)
          } else {
            $('.J-newCustomer-time').parent().addClass('display-none').siblings().removeClass('display-none')
          }
          $('.J-newCustomer-joined .J-newCustomer-couponTip').text(res.expand_field.applicable_text)
          $('.J-newCustomer-cr').text(shopCR)

          // 处理OS可配置的额外新增文案
          if (res?.expand_field?.usage_desc) {
            this.handleExpandText(res, 'res')
          }

          if ([0, 1, 2].includes(res.welfate_type)) {
            if ([0, 1].includes(res.welfate_type)) {
              $('.J-newCustomer-joined .J-newCustomer-coupon-text .coupon').removeClass('display-none').siblings().addClass('display-none')
            } else {
              $('.J-newCustomer-joined .J-newCustomer-coupon-text .sku-coupon').removeClass('display-none').siblings().addClass('display-none')
            }
          } else {
            $('.J-newCustomer-joined .J-newCustomer-coupon-text .card').removeClass('display-none').siblings().addClass('display-none')
          }
          $('.J-code-tip').removeClass('display-none')
          $('.J-newCustomer-joined .J-newCustomer-code').text(res.expand_field.code)
        }
      } else {
        this.handleRecaptcha(res)
      }
      console.log('email success ~~~~')
      // GA
      const gaParams = {
        module: 'Subscribe Submit',
        position: 'subscribe_success',
        button_name: $('.J-newCustomer-submit').text().trim()
      }
      this.NewCustomerGAEvent(gaParams)
    }).catch((err) => {
      if (err.code === 62004) {
        this.customerPrizesPoll(obj)
      } else {
        this.joinStatus = false
        $('.J-newCustomer-one').removeClass('display-none')
        $('.J-newCustomer-two').addClass('display-none')
        $('.J-customer-recaptcha').addClass('display-none')
        $('.J-newCustomer-close').attr('customer-current-step', 'one')

        $('.J-newCustomer-tip').fadeIn().text(err.message)
        if (this.backgroundMode === 'small') {
          if (isMobile() && window.screen.width <= 768) {
            $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.web_main_banner_url)
          } else {
            $('.J-newCustomer-one .gift-box img').attr('src', this.customerParams.pc_main_banner_url)
          }
        }else {
          if (isMobile() && window.screen.width <= 768) {
            $('.new-customer-box').css('background', `white url(${this.customerParams.web_full_main_banner_url}) center center /cover no-repeat`)
          } else {
            $('.new-customer-box').css('background', `white url(${this.customerParams.pc_full_main_banner_url}) center center /cover no-repeat`)
          }
        }
      }
    })
  }

  // 处理 券码包 弹窗
  handleCouponPkg(res) {
    $('.new-customer-box').css('background', 'white')
    // 显示券码包
    $('.J-newCustomer-one').addClass('display-none')
    $('.J-newCustomer-three').addClass('display-none')
    this.couponPkgWrapDOM.classList.remove('display-none')

    // 处理标题
    this.couponPkgWrapDOM.querySelector('.title').innerText = res.main_title
    this.couponPkgWrapDOM.querySelector('.subtitle').innerText = res.sub_title

    //券码包内容 ------PC端os配置文案，按钮下方详情文案
    if (res.detailed_desc) {
      this.handleMoreText(res.detailed_desc)
    }

    // 清空
    this.couponPkgListWrapDOM.innerHTML = ''

    const length = res?.coupons?.length || 0
    // 处理 样式
    if (!isMobile()) {
      if (length < 3) {
        this.couponPkgListWrapDOM.classList.add('flex-col')
        this.couponPkgListWrapDOM.classList.add('flex-center')
        this.couponPkgListWrapDOM.classList.remove('flex-start')
        this.couponPkgListWrapDOM.classList.remove('content-start')
      } else {
        this.couponPkgListWrapDOM.classList.add('flex-start')
        this.couponPkgListWrapDOM.classList.remove('flex-col')
        this.couponPkgListWrapDOM.classList.remove('flex-center')

        if (length < 3) {
          this.couponPkgListWrapDOM.classList.remove('content-start')
          this.couponPkgListWrapDOM.classList.add('content-center')
        } else {
          this.couponPkgListWrapDOM.classList.remove('content-center')
          this.couponPkgListWrapDOM.classList.add('content-start')
        }
      }

      if (length === 2) {
        this.couponPkgListWrapDOM.style.paddingLeft = '8px'
      } else {
        this.couponPkgListWrapDOM.style.paddingLeft = '0px'
      }
    } else {
      if (length < 3) {
        this.couponPkgListWrapDOM.classList.remove('content-start')
        this.couponPkgListWrapDOM.classList.add('content-center')
      } else {
        this.couponPkgListWrapDOM.classList.remove('content-center')
        this.couponPkgListWrapDOM.classList.add('content-start')
      }
    }


    // 遍历 优惠券
    let html = ''
    let usageDescArray = []
    const { orderOver, noMinimum, copySuccess, hasExpired, notValid, noValidTime, } = this.couponPkgListWrapDOM.dataset
    res?.coupons.forEach((
      { reward_url, code, limit_amount, applicable_text, start_at_desc, end_at_desc, coupon_button_name, usable, coupon_button_url, usage_desc, welfare_type},
      index
    ) => {
      const text = limit_amount > 0 ? `${orderOver} ${formatMoney(limit_amount * 100, window.pageInfo.currency.money_format)}` : noMinimum
      const validTime = `${start_at_desc.replaceAll('/', '.')} ~ ${end_at_desc.replaceAll('/', '.')}`
      usageDescArray.push({ welfare_type, usage_desc, })
      html += `
        <li class="coupon-pkg-list-item" data-usable="${usable}">
          <div class="flex-shrink-0 flex-start flex-col w-270 mt-2 lg:j-w-140 lg:j-mt-2 xl:a-w-140 xl:a-mt-2 relative">
            <img class="w-270 h-180 lg:j-w-140 lg:j-h-94 xl:a-w-140 xl:a-h-94 scale-1.15" src="${reward_url}" alt="">
            <p
              class="relative w-[120%] font-semibold break-all text-center text-#666 text-24 leading-28 -mt-6 lg:j-text-12 lg:j-leading-14 -lg:j-mt-3 xl:a-text-12 xl:a-leading-14 -xl:a-mt-3"
            >Code: ${code}</p>
            <p data-copy-code-tip></p>
          </div>
          <div class="flex flex-col items-end flex-1 mt-14 lg:j-mt-8 xl:a-mt-8">
            <p
              class="
                font-bold text-#333 text-28 leading-32 mb-4 underline cursor-pointer
                lg:j-text-14 lg:j-leading-16 lg:j-mb-2 xl:a-text-14 xl:a-leading-16 xl:a-mb-2
              "
              data-coupon-pkg-rules
              data-cr="${shopCR}"
              data-valid-time="${validTime}"
              data-end-at-desc="${end_at_desc}"
              data-limit-amount="${limit_amount}"
              data-applicable-text="${applicable_text}"
              data-index="${index}"
            >Rules</p>
            <p class="flex items-center font-medium text-#9F5E2B h-56 text-end text-24 leading-28 line-clamp-2 lg:j-h-28 lg:j-text-12 lg:j-leading-14 xl:a-h-28 xl:a-text-12 xl:a-leading-14">${text}</p>
            ${
              end_at_desc
                ? `<p class="font-medium text-#9F5E2B text-24 leading-28 my-10 lg:j-text-12 lg:j-leading-14 lg:j-my-6 xl:a-text-12 xl:a-leading-14 xl:a-my-6">${validTime}</p>`
                : `<p class="font-medium text-#9F5E2B text-24 leading-28 my-10 lg:j-text-12 lg:j-leading-14 lg:j-my-6 xl:a-text-12 xl:a-leading-14 xl:a-my-6">${noValidTime}</p>`
            }
            <button
              class="text-center rounded-full bg-primary text-white font-bold text-25 min-w-172 h-52 px-32 lg:j-text-13 lg:j-min-w-90 lg:j-h-26 lg:j-px-10 xl:a-text-13 xl:a-min-w-90 xl:a-h-26 xl:a-px-10"
              data-usable="${usable}"
              data-code="${code}"
              data-button-url="${coupon_button_url}"
              data-coupon-pkg-button
            >${coupon_button_name}</button>
          </div>
        </li>
      `
    })

    this.couponPkgListWrapDOM.innerHTML = html

    // 全部已过期，主动弹窗提示
    const noExpiredCoupons = res?.coupons.filter(it => it.usable !== '2')
    if (!noExpiredCoupons.length) {
      this.handlePkgTips(hasExpired)
    }

    // 处理券码包 button 点击
    this.handlePkgButton(copySuccess, hasExpired, notValid)

    // 处理 Rules Tips 弹窗
    this.handleRuleTips(usageDescArray)

    const walletBtnDOM = this.couponPkgWrapDOM.querySelector('[data-coupon-pkg-wallet-btn]')
    const exploreBtnDOM = this.couponPkgWrapDOM.querySelector('[data-coupon-pkg-explore-btn]')

    if ((shopCR === 'US' || shopCR === 'GB') && res.task_type === 0) {
      walletBtnDOM.innerText = res.button_one_desc || 'Win More'
    }else if(shopCR === 'DE' && res.task_type === 0){
      walletBtnDOM.innerText = res.button_one_desc || 'Gewinne Mehr'
    }else if(res.button_one_desc && res.task_type === 0){
      walletBtnDOM.innerText = res.button_one_desc
    }

    // button 按钮  我的钱包，更多 没有文案仅展示我的钱包
    if (res.button_desc[0]) {
      exploreBtnDOM.innerText = res.button_desc[0]
      exploreBtnDOM.style.display = 'block'
    } else {
      exploreBtnDOM.style.display = 'none'
    }

    // 添加点击事件监听器
    walletBtnDOM.addEventListener('click', (e) => {
      const id_url = window.shopId !== '55005249633'
          ? `https://account.jackery.com/account/wallet?cr=${shopCR}`
          : `http://demo-account.jackery.com/account/wallet?cr=${shopCR}`

      // const emailVal = $('.J-newCustomer-email')[0].value
      //自定义三方代码,调起 klaviyo 弹窗
      if(res.script && res.task_type === 0){
        this.openKlaviyoForm(res.script)
      }
      else {
        // 因为苹果的安全机制拦截了，所以不能打开新的标签页
        isiOS() ? (window.location.href = id_url) : window.open(id_url, '_blank')
      }

      // 上报数据
      this.getCustomerPopup('coupon_package_btn_my_wallet')

      // 数据埋码
      this.GAEvent({
        module: res.main_title || 'No.3 PoPup',
        button_name: e.target.innerText,
        link: id_url,
      })
    })
    exploreBtnDOM.addEventListener('click', (e) => {
      const button_url = res.button_url
      // 在新标签页中打开新的 URL
      if (button_url) {
        // 因为苹果的安全机制拦截了，所以不能打开新的标签页
        isiOS() ? (window.location.href = button_url) : window.open(button_url, '_blank')
      } else {
        // 如果没有设置链接，则默认关闭弹框并停留在当前页面
        $('#new-customer-pop').removeClass("active").fadeOut()
        // 恢复 内容区域 宽度
        resetContentWidth()
      }

      // 上报数据
      this.getCustomerPopup('coupon_package_btn_more')

      // 数据埋码
      this.GAEvent({
        module: res.main_title || 'No.3 PoPup',
        button_name: e.target.innerText,
        link: button_url || null,
      })
    })
  }

  // 打开 Klaviyo 弹窗表单
  openKlaviyoForm(code) {
     // 先关闭拉新弹窗，防止code错误点击不动
     $('#new-customer-pop').removeClass("active").fadeOut()
     // 恢复 内容区域 宽度
     resetContentWidth()
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', code]);

    // 监听 klaviyo 弹窗打开
    window.addEventListener("klaviyoForms", function(e) {
      if (e.detail.type == 'open') {

        // 关联 email
        // klaviyo.push(['identify', {
        //   // Change the line below to dynamically print the user's email.
        //   'email' : emailVal
        // }]);
      }
      if (e.detail.type == 'submit') {
        // 关联 email
        // klaviyo.push(['identify', {
        //   'email' : emailVal
        // }]);
      }
    });
  }

  // 处理重复参与
  handleRepeat(res) {
    // 重复参与活动
    $('.J-newCustomer-one').addClass('display-none')
    $('.new-customer-box').css('background', 'white')
    $('.J-newCustomer-joined').removeClass('display-none')
    $('.J-newCustomer-joined .title').text(res.finish_main_title).css('color', res.main_color)
    $('.J-newCustomer-joined .subtitle').text(res.finish_sub_title).css('color', res.sub_color)
    $('.J-newCustomer-joined .awards-show img').attr('src', res.reward_url || res.expand_field?.reward_url)

    // 处理操作按钮
    $('.J-newCustomer-joined .option-button').removeClass('display-none')
    this.handleOptionButton(res)
  }

  // 轮询
  customerPrizesPoll(obj) {
    let timer = null;
    timer = setTimeout(() => {
      customerResult(obj).then((r) => {
        let res = r.data;
        this.customer_result = res;

        this.handleRecaptcha(res)
        console.log('email success ~~~~')
        // GA
        const gaParams = {
          module: 'Subscribe Submit',
          position: 'subscribe_success',
          button_name: $('.J-newCustomer-submit').text().trim()
        }
        this.NewCustomerGAEvent(gaParams)
        clearTimeout(timer)
      }).catch((err) => {
        if (err.code === 62004) {
          // 继续轮询
          this.customerPrizesPoll(obj)
        } else {
          this.joinStatus = false
          $('.J-newCustomer-one').removeClass('display-none')
          $('.J-newCustomer-two').addClass('display-none')
          $('.J-customer-recaptcha').addClass('display-none')
          $('.J-newCustomer-tip').fadeIn().text(err.message)
          $('.J-newCustomer-close').attr('customer-current-step', 'one')
          clearTimeout(timer)
        }
      })
    }, 1000)
  }

  handleRecaptcha({ welfate_type, status, task_type, explain_desc, }) {
    // 虚拟礼品卡，人机校验
    if (welfate_type === 5 && status === 5 && task_type === 0) {
      // 虚拟礼品卡
      // setTimeout(() => {
        $('.J-newCustomer-two').addClass('display-none')
        $('.J-customer-recaptcha').removeClass('display-none')
        const cardTip = explain_desc ? explain_desc[0] : '';
        $('.J-customer-recaptcha .title').text(cardTip)
      // }, 1000)
    } else {
      // setTimeout(() => {
        $('.J-newCustomer-two').addClass('display-none')
        $('.J-customer-recaptcha').addClass('display-none')
        $('.J-newCustomer-three').removeClass('display-none')

        this.customerPrizesShow()
      // }, 1000)
    }
  }

  // 展示奖品
  customerPrizesShow() {
    // 先判断是何种任务类型,再判断福利类型
    // task_type任务类型：0 - 订阅，1 - 注册、激活，2 - 激活完成，3 - 电话订阅，4 - 无任务
    // welfate_type福利类型：0：优惠券-百分比折扣, 1：优惠券-固定金额折扣， 2：优惠券-实物类型，3：虚拟奖品-宽泛礼品卡，4：SHOPIFY礼品卡
    $('.J-newCustomer-left').parent().removeClass('option-button-register')

    // 注册/激活
    if (this.customer_result.task_type === 1 && this.customer_result.status !== 1) {
      $('.J-newCustomer-close').attr('customer-current-step', 'three-register')
      // 需要显示主标题、副标题、奖品图片、两个按钮(不可配置)、提示文案
      let left_text = $('.J-newCustomer-left').data('register-left')
      let right_text = $('.J-newCustomer-right').data('register-right')
      $('.J-newCustomer-three .option-button').removeClass('display-none')
      $('.J-newCustomer-left').text(left_text).hide()
      $('.J-newCustomer-right').text(right_text)
      $('.J-newCustomer-left').parent().addClass('option-button-register')
      $('.J-register-tip').removeClass('display-none')

      // 处理标题和图片
      this.handleTitleAndImg(this.customer_result)
    }
    // 电话订阅
    else if (this.customer_result.task_type === 3 && this.customer_result.status !== 1) {
      $('.J-newCustomer-close').attr('customer-current-step', 'three-phone')
      $('.J-newCustomer-three .customer-phone').removeClass('display-none')

      // 处理标题和图片
      this.handleTitleAndImg(this.customer_result)
    }
    else {
      $('.J-newCustomer-close').attr('customer-current-step', 'three-result')

      // 虚拟奖品，说明文案及备注需要特殊处理
      if (this.customer_result.welfate_type === 3) {
        if (this.customer_result.reward_rules?.length) {
          $('.J-newCustomer-virtual-text').removeClass('display-none')
          const str =
            this.customer_result.reward_rules
              .filter(it => it !== '')
              .reduce((p, n) => p += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`, '')
          $('.J-newCustomer-virtual-text').html(str)
        }

        // 处理操作按钮
        $('.J-newCustomer-three .option-button').removeClass('display-none')
        this.handleOptionButton(this.customer_result)

        if (this.customer_result.explain_desc?.length) {
          $('.J-newCustomer-virtual-explain').removeClass('display-none')
          const str =
            this.customer_result.explain_desc
              .filter(it => it !== '')
              .reduce((p, n) => p += `<div>${n}</div>`, '')
          $('.J-newCustomer-virtual-explain').html(str)
        }

        // 处理标题和图片
        this.handleTitleAndImg(this.customer_result)
      }
      // 虚拟礼品卡
      else if (this.customer_result.welfate_type === 5) {
        if (this.customer_result.button_one_desc || this.customer_result.button_two_desc) {
          // 处理操作按钮
          $('.J-newCustomer-three .option-button').removeClass('display-none')
          this.handleOptionButton(this.customer_result)
        } else {
          $('.J-newCustomer-three .option-button').addClass('display-none')
        }

        // 处理 虚拟礼品卡 规则
        this.handleVirtualRules(this.customer_result, 'virtual')

        // 处理标题和图片
        this.handleTitleAndImg(this.customer_result)
      }
      //券码包内容
      else if (this.customer_result.welfate_type === 10) {
        this.handleCouponPkg(this.customer_result)
      } else {
        $('.J-newCustomer-coupon-text').removeClass('display-none')
        $('.J-code-tip').removeClass('display-none')
        $('.J-newCustomer-limit').text(formatMoney(this.customer_result.expand_field.limit_amount * 100, window.pageInfo.currency.money_format))
        if (this.customer_result.expand_field.limit_amount == 0) {
          $('.J-newCustomer-limit').parent().addClass('display-none').siblings().removeClass('display-none')
        }
        // 如果有有效期截止时间，则显示有效期，否则不显示
        if (this.customer_result.expand_field.end_at_desc) {
          $('.J-newCustomer-time').text(this.customer_result.expand_field.start_at_desc + ' ~ ' + this.customer_result.expand_field.end_at_desc)
        } else {
          $('.J-newCustomer-time').parent().addClass('display-none').siblings().removeClass('display-none')
        }
        $('.J-newCustomer-code').text(this.customer_result.expand_field.code)
        $('.J-newCustomer-couponTip').text(this.customer_result.expand_field.applicable_text)
        $('.J-newCustomer-cr').text(shopCR)

        // 处理OS可配置的额外新增文案
        if (this.customer_result?.expand_field?.usage_desc) {
          this.handleExpandText(this.customer_result, 'result')
        }

        if ([0, 1, 2].includes(this.customer_result.welfate_type)) {
          if ([0, 1].includes(this.customer_result.welfate_type)) {
            $('.J-newCustomer-coupon-text .coupon').removeClass('display-none').siblings().addClass('display-none')
          } else {
            $('.J-newCustomer-coupon-text .sku-coupon').removeClass('display-none').siblings().addClass('display-none')
          }
        } else {
          $('.J-newCustomer-coupon-text .card').removeClass('display-none').siblings().addClass('display-none')
        }

        // 处理操作按钮
        $('.J-newCustomer-three .option-button').removeClass('display-none')
        this.handleOptionButton(this.customer_result)

        // 处理标题和图片
        this.handleTitleAndImg(this.customer_result)
      }
    }
  }

  // 处理标题和图片
  handleTitleAndImg(res) {
    // 券码包
    if (res.welfate_type === 10) {
      $('.J-newCustomer-three .title').text(res.main_title).css('color', res.main_color)
      $('.J-newCustomer-three .subtitle').text(res.sub_title).css('color', res.sub_color)
      $('.J-newCustomer-prizes-img').attr('data-coupon-pkg', '1').html(`
        <picture style="width:100%;height:100%;">
          <source media="(min-width:1024px)" data-srcset="${res.image_web_url}">
          <img style="width:100%;height:100%;" class="lazyload" data-src="${res.image_mobile_url}" alt="" loading="lazy">
        </picture>
      `)
    }
    // 非券码包
    else {
      $('.J-newCustomer-three .title').text(res.finish_main_title).css('color', res.main_color)
      $('.J-newCustomer-three .subtitle').text(res.finish_sub_title).css('color', res.sub_color)
      $('.J-newCustomer-prizes-img').attr('data-coupon-pkg', '0').html(`
        <img class="lazyload" data-src="${res.reward_url || res?.expand_field?.reward_url}" alt="" loading="lazy"/>
      `)
    }
  }

  // 处理OS可配置的额外新增文案
  handleExpandText({ welfate_type, expand_field, }, type) {
    let type_class = ''
    if (type === 'res') {
      type_class = [0, 1].includes(welfate_type) ? '.J-newCustomer-joined .J-newCustomer-coupon-text .coupon' : welfate_type === 2 ? '.J-newCustomer-joined .J-newCustomer-coupon-text .sku-coupon' : '.J-newCustomer-joined .J-newCustomer-coupon-text .card';
    } else {
      type_class = [0, 1].includes(welfate_type) ? '.J-newCustomer-three .J-newCustomer-coupon-text .coupon' : welfate_type === 2 ? '.J-newCustomer-three .J-newCustomer-coupon-text .sku-coupon' : '.J-newCustomer-three .J-newCustomer-coupon-text .card';
    }

    // 金额优惠券、折扣优惠券、礼品卡，前置到第2行并高亮
    if ([0, 1, 4].includes(welfate_type)) {
      const text_str =
        expand_field.usage_desc
          .filter(it => it !== '')
          .reduce((p, n) => p += `<div class="coupon-item" style="color:#FD5000;"><span class="item-icon"></span>${n}</div>`, '')

      // 在第 1 个元素后追加
      $(type_class).find('.Mob-show').find('.coupon-item').eq(0).after(text_str)

      // 在第 1 个元素后追加
      $(type_class).find('.PC-show .coupon-wrap').find('.coupon-item').eq(0).after(text_str)

      const pc_item_length = $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').length
      const origin_dom = $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').clone()
      const more_text = $('.J-newCustomer-coupon-text').data('more-text')

      // 只显示前3个
      if (pc_item_length > 3) {
        $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').eq(2).append(`<span class="more" style="font-weight:bold;"> ${more_text}</span>`)

        if ($(type_class).find('.PC-show').has('.toolTip').length) {
          $(type_class).find('.PC-show .toolTip').children('.coupon-item').eq(0).after(text_str)
        } else {
          const tooltipDOM = `<div class="toolTip"></div>`
          $(type_class).find('.PC-show').append(tooltipDOM)
          $(type_class).find('.PC-show .toolTip').prepend(origin_dom)
        }
      }
      $(type_class).find('.PC-show .coupon-wrap').html(
        $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').slice(0, 3)
      )
    }
    else {
      const pc_item_length = $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').length
      const origin_dom = $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').clone()
      const more_text = $('.J-newCustomer-coupon-text').data('more-text')
      const text_str =
        expand_field.usage_desc
          .filter(it => it !== '')
          .reduce((p, n) => p += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`, '')

      if (pc_item_length < 3) {
        let pc_text_str = '';
        let all_text_str = '';
        expand_field.usage_desc.forEach((n, i) => {
          if (pc_item_length + expand_field.usage_desc.length > 3) {
            if (pc_item_length + i + 1 < 3) {
              pc_text_str += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`
            }
            if (pc_item_length + i + 1 == 3) {
              pc_text_str += `<div class="coupon-item"><span class="item-icon"></span>${n}<span class="more">${more_text}</span></div>`
            }
            all_text_str += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`
          } else {
            pc_text_str += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`
          }
        })
        $(type_class).find('.PC-show .coupon-wrap').append(pc_text_str)
        if (pc_item_length + expand_field.usage_desc.length > 3) {
          all_text_str = `<div class="toolTip">${all_text_str}</div>`
          $(type_class).find('.PC-show').append(all_text_str)
          $(type_class).find('.PC-show .toolTip').prepend(origin_dom)
        }
      } else if (pc_item_length == 3) {
        if ($(type_class).find('.PC-show').has('.toolTip').length) {
          $(type_class).find('.PC-show .toolTip').append(text_str)
        } else {
          $(type_class).find('.PC-show .coupon-wrap').children('.coupon-item').eq(2).append(`<span class="more"> ${more_text}</span>`)
          let all_text_str = `<div class="toolTip">${text_str}</div>`
          $(type_class).find('.PC-show').append(all_text_str)
          $(type_class).find('.PC-show .toolTip').prepend(origin_dom)
        }
      }
      $(type_class).find('.Mob-show').append(text_str)
    }
  }

  // 处理操作按钮
  handleOptionButton({ button_one_desc, button_one_link, button_two_desc, button_two_link, }) {
    if (button_one_desc) {
      $('.J-newCustomer-left').text(button_one_desc).show()
      $('.J-newCustomer-left').attr('left-button-link', button_one_link)
    } else {
      $('.J-newCustomer-left').hide()
    }

    if (button_two_desc) {
      $('.J-newCustomer-right').text(button_two_desc).show()
      $('.J-newCustomer-right').attr('right-button-link', button_two_link)
    } else {
      $('.J-newCustomer-right').hide()
    }
  }

  // 处理 虚拟礼品卡 规则
  handleVirtualRules({ reward_rules, }, type) {
    if (reward_rules) {
      let pc_dom = '';
      const more_text = $('.J-newCustomer-coupon-text').data('more-text');
      const text_str =
        reward_rules
          .filter(it => it !== '')
          .reduce((p, n) => p += `<div class="coupon-item"><span class="item-icon"></span>${n}</div>`, '')

      const mob_dom = `<div class="Mob-show">${text_str}</div>`

      if (reward_rules.length > 3) {
        const tip_dom = `<div class="toolTip">${text_str}</div>`
        let dom = ''
        reward_rules.map((item, index) => {
          if (index + 1 < 3) {
            dom += `<div class="coupon-item"><span class="item-icon"></span>${item}</div>`
          }
          if (index + 1 == 3) {
            dom += `<div class="coupon-item"><span class="item-icon"></span>${item} <span class="more">${more_text}</span></div>`
          }
        })
        pc_dom = `<div class="PC-show">
          <div class="coupon-wrap">${dom}</div>
          ${tip_dom}
        </div>`
      } else {
        pc_dom = `<div class="PC-show"><div class="coupon-wrap">${text_str}</div></div>`
      }

      const virtual_dom = pc_dom + mob_dom
      if (type === 'virtual') {
        $('.J-newCustomer-virtual-explain').removeClass('display-none').html(virtual_dom)
      }
      if (type === 'explain') {
        $('.J-newCustomer-joined-virtualExplain').removeClass('display-none').html(virtual_dom)
      }
    }
  }

  // 输入框交互
  emailFocus() {
    $('.J-newCustomer-tip').fadeOut()
    $('.J-newCustomer-checkbox').removeClass('error')
    isMobile() ? $('.J-newCustomer-email').removeClass('shake-bottom') : $('.J-newCustomer-form').removeClass('shake-bottom')
  }

  // 奖品展示按钮
  newCustomerLeftClick() {
    if (this.customer_result.task_type === 1) {
      this.getCustomerPopup('reg_left_button')
      // 暂时默认关闭弹框留在当前页面
      $('#new-customer-pop').removeClass("active").fadeOut()

      // 恢复 内容区域 宽度
      resetContentWidth()
    } else {
      this.getCustomerPopup('result_left_button')

      //自定义三方代码,调起 klaviyo 弹窗
      if(this.customer_result.script && this.customer_result.task_type === 0){
        this.openKlaviyoForm(this.customer_result.script)
      }

      else {
        const link = $('.J-newCustomer-left').attr('left-button-link')
        if (link) {
          // 因为苹果的安全机制拦截了，所以不能打开新的标签页
          isiOS()
            ? (window.location.href = link + '?selfEmail=' + this.join_params.email)
            : window.open(link + '?selfEmail=' + this.join_params.email, '_blank')
        } else {
          // 如果没有设置链接，则默认关闭弹框并停留在当前页面
          $('#new-customer-pop').removeClass("active").fadeOut()

          // 恢复 内容区域 宽度
          resetContentWidth()
        }
      }
    }
  }

  async newCustomerRightClick() {
    if (this.customer_result.task_type === 1 && this.customer_result.status !== 1) {
      this.getCustomerPopup('reg_right_button')
      localStorage.removeItem('pageCustomerTask')
      // 跳转ID注册页面
      let id_url = window.shopId !== '55005249633' ? `https://account.jackery.com` : `http://demo-account.jackery.com`

      // status 2 表示需要注册（跳转注册）， 3 表示 需要激活（跳转登录）
      id_url = id_url + (this.customer_result.status === 2 ? `/register` : `/login`)

      let uparams = {
        act_params: {
          join_token: this.join_params.join_token,
        },
        register_act: "app_newcomer_subscribe",
        return_url: `${window.location.origin}?newCustomerTask=true&email=${this.join_params.email}&join_token=${this.join_params.join_token}`,
      }
      id_url = id_url + `?cr=${shopCR}&uparams=${encodeURIComponent(JSON.stringify(uparams))}`

      // 因为苹果的安全机制拦截了，所以不能打开新的标签页
      // isiOS() ? (window.location.href = id_url) : window.open(id_url, '_blank')
      $('#new-customer-pop').removeClass("active").fadeOut()
      if(window.jackeryLoginApp) {
        window.jackeryLoginApp.modalLogin({
          register_act: 'app_newcomer_subscribe',
          return_url: `${window.location.origin}?newCustomerTask=true&email=${this.join_params.email}&join_token=${this.join_params.join_token}`,
          act_params:{join_token: this.join_params.join_token}
        })
      }
      return
    } else {
      if (this.customer_result.welfate_type !== 2) {
        this.getCustomerPopup('result_right_button')
      }
      if (this.customer_result.expand_field?.code) {
        copyString(this.customer_result.expand_field.code)
      }
      let link = $('.J-newCustomer-right').attr('right-button-link')
      if (link) {
        // 因为苹果的安全机制拦截了，所以不能打开新的标签页
        isiOS()
          ? (window.location.href = link + '?selfEmail=' + this.join_params.email)
          : window.open(link + '?selfEmail=' + this.join_params.email, '_blank')
      } else {
        if (this.customer_result.welfate_type === 2) {
          this.getCustomerPopup('product_now')
          // 实物优惠券，且没有配置跳转链接则默认跳转结账页
          let d = new Date()
          d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
          document.cookie = `discount_code=${this.customer_result.expand_field.code};expires=${d.toGMTString()};path=/`
          const params = [{ id: this.customer_result.goods_id, quantity: 1, properties: {}, }]
          try {
              const checkoutUrl = await createCartAndCheckout(params)
              if (checkoutUrl) {
                window.location.href = checkoutUrl
              }
          } catch (error) {
              window.location.href = `${window.location.origin}/cart/${this.customer_result.goods_id}:1?discount=${this.customer_result.expand_field.code}`
          }
        } else {
          this.getCustomerPopup('result_right_button')
          // 如果没有设置链接，则默认关闭弹框并停留在当前页面
          $('#new-customer-pop').removeClass("active").fadeOut()

          // 恢复 内容区域 宽度
          resetContentWidth()
        }
      }
    }
  }

  // 复制 code 码
  newCustomerCodeClick(e) {
    const code = e.target.innerText
    copyString(code)
    $('.J-newCustomer-code-tip').fadeIn().delay(1000).fadeOut()
  }

  // 点击提交电话号
  newCustomerPhoneSubmitClick() {
    const phoneVal = $('.J-newCustomer-phone').val()
    const checkboxVal = $('.J-newCustomer-phoneCheckbox input').is(':checked')

    // 上报数据
    this.getCustomerPopup('phone_button')

    // 校验
    $('.J-newCustomer-phoneTip').hide()
    $('.J-newCustomer-phoneCheckbox').removeClass('error')
    phoneVal === ''
      ? $('.J-newCustomer-phoneTip').fadeIn().text($('.J-newCustomer-phoneTip').data('phone-empty'))
      : !checkboxVal
        ? $('.J-newCustomer-phoneCheckbox').addClass('error')
        : ''

    if ($('.J-newCustomer-phoneCheckbox').hasClass('error')) {
      return false
    }

    if ($('.J-newCustomer-phoneTip').is(':hidden')) {
      let params = {
        join_token: this.join_params.join_token,
        email: this.join_params.email,
        phone: phoneVal
      }
      customerPhone(params).then(() => {
        // 电话订阅成功后，重新调result接口获取开奖结果并展示
        this.phoneResult({
          join_token: this.join_params.join_token,
          email: this.join_params.email
        })
      }).catch(err => {
        $('.J-newCustomer-phoneTip').fadeIn().text(err.message)
      })
    } else {
      isMobile() ? $('.J-newCustomer-phone').addClass('shake-bottom') : $('.J-newCustomer-phoneForm').addClass('shake-bottom')
    }
  }

  // 电话订阅成功后，获取奖品数据
  phoneResult(obj) {
    customerResult(obj).then((res) => {
      $('.J-newCustomer-three .customer-phone').addClass('display-none')
      this.customer_result = res.data
      this.customerPrizesShow()
      console.log('phone success ~~~~~')
      // GA
      const gaParams = {
        module: 'Subscribe Submit',
        position: 'subscribe_success',
        button_name: $('.J-newCustomer-phoneSubmit').text().trim()
      }
      this.NewCustomerGAEvent(gaParams)
    })
  }

  getCustomerPopup(type) {
    let params = {
      act_id: this.customerParams.act_id,
      type: type
    }
    customerPopData(params).then((res) => {})
  }

  // 图片预加载
  preloader(src) {
    if (src) {
      let img = new Image()
      img.src = src
    }
  }

  customerPopShow(res) {
    this.customerPopTimer = setTimeout(() => {
      $('#new-customer-pop').fadeIn().delay(300).addClass("active")

      // 设置 内容区域 宽度，防止 页面闪烁
      setContentWidth()

      this.initCustomerData()
      this.getCustomerPopup('popup_home')
    }, 0 + (res?.windowShowDelaySecond || 0) * 1000)
  }

  // 处理券码包 已过期，待生效 的提示
  handlePkgTips(text) {
    $('[data-coupon-pkg-error-tip]')
      .removeClass('display-none')
      .fadeIn()
      .find('.error-tip-text')
      .text(text)
      .parent().parent()
      .delay(3000)
      .fadeOut()
  }

  // 处理券码包的 button 点击
  handlePkgButton(copySuccess, hasExpired, notValid) {
    const couponPkgBtns = this.couponPkgListWrapDOM.querySelectorAll('[data-coupon-pkg-button]')
    couponPkgBtns.forEach(it => {
      it.addEventListener('click', (e) => {
        const { usable, code, buttonUrl, } = e.target.dataset
        if (usable === '0') {
          if (code) {
            copyString(code)
            const codeTipDOM = e.target.parentElement.parentElement.querySelector('[data-copy-code-tip]')
            codeTipDOM.innerText = copySuccess
            codeTipDOM.style.display = 'block'
            setTimeout(() => {
              codeTipDOM.style.display = 'none'
              if (buttonUrl) {
                // 因为苹果的安全机制拦截了，所以不能打开新的标签页
                isiOS() ? (window.location.href = buttonUrl) : window.open(buttonUrl, '_blank')
              }
            }, 1000)
          } else {
            if (buttonUrl) {
              // 因为苹果的安全机制拦截了，所以不能打开新的标签页
              isiOS() ? (window.location.href = buttonUrl) : window.open(buttonUrl, '_blank')
            }
          }
        }
        else if (usable === '2') {
          this.handlePkgTips(hasExpired)
        }
        else if (usable === '4') {
          this.handlePkgTips(notValid)
        }

        // 数据埋码
        this.GAEvent({
          module: this.customer_result.main_title || 'No.3 PoPup',
          position: code, // 识别优惠券 券码code
          total: `count_coupons_${couponPkgBtns.length}`,
          button_name: e.target.innerText,
          link: buttonUrl || null,
        })
      })
    })
  }

  // 处理券码包的 Rules Tip 弹窗
  handleRuleTips(usageDescArray) {
    const couponRulesTipDOM = document.querySelector('.coupon-pkg-rules-tip')
    const couponPkgRulesDOMs = document.querySelectorAll('[data-coupon-pkg-rules]')

    let timer = null
    let scrollTop = 0
    this.couponPkgListWrapDOM.addEventListener('scroll', (e) => {
      scrollTop = e.target.scrollTop

      clearTimeout(timer)
      couponPkgRulesDOMs.forEach(it => it.classList.remove('rule-tip-show'))
      couponRulesTipDOM.style.display = 'none'
    })

    // 鼠标移入 | touchend
    const enterEvent = (e, it) => {
      clearTimeout(timer)
      it.classList.add('rule-tip-show')

      const { cr, validTime, endAtDesc, limitAmount, applicableText, index, } = e.target.dataset
      const usageDesc = usageDescArray[index].usage_desc
      const welfareType = usageDescArray[index].welfare_type

      if (limitAmount > 0) {
        couponRulesTipDOM.querySelector('.J-newCustomer-limit').innerHTML = formatMoney(limitAmount * 100, window.pageInfo.currency.money_format)
        couponRulesTipDOM.querySelector('.J-newCustomer-order-over').style.display = 'inline-block'
        couponRulesTipDOM.querySelector('.J-newCustomer-no-minimum').style.display = 'none'
      } else {
        couponRulesTipDOM.querySelector('.J-newCustomer-order-over').style.display = 'none'
        couponRulesTipDOM.querySelector('.J-newCustomer-no-minimum').style.display = 'inline-block'
      }

      // 如果有有效期截止时间，则显示有效期，否则不显示
      if (endAtDesc) {
        couponRulesTipDOM.querySelector('.J-newCustomer-time').innerHTML = validTime
        couponRulesTipDOM.querySelector('.J-newCustomer-valid-time').style.display = 'inline-block'
        couponRulesTipDOM.querySelector('.J-newCustomer-no-valid-time').style.display = 'none'
      } else {
        couponRulesTipDOM.querySelector('.J-newCustomer-valid-time').style.display = 'none'
        couponRulesTipDOM.querySelector('.J-newCustomer-no-valid-time').style.display = 'inline-block'
      }
      
      if (applicableText) {
        couponRulesTipDOM.querySelector('.J-newCustomer-couponTip').parentElement.style.display = 'flex'
        couponRulesTipDOM.querySelector('.J-newCustomer-couponTip').innerHTML = applicableText
      } else {
        couponRulesTipDOM.querySelector('.J-newCustomer-couponTip').parentElement.style.display = 'none'
      }

      couponRulesTipDOM.querySelector('.J-newCustomer-cr').innerHTML = cr


      // 清空 usage-desc li 元素
      couponRulesTipDOM.querySelector('ol').querySelectorAll('.usage-desc-li')?.forEach(item => {
        item.parentElement.removeChild(item)
      })
      if (usageDesc?.length) {
        // 金额优惠券、折扣优惠券、礼品卡，前置到第2行并高亮
        if ([0, 1, 4].includes(welfareType)) {
          usageDesc.forEach((item, index) => {
            const li = document.createElement('li')
            li.className = 'usage-desc-li'
            li.innerHTML = `
              <span class="item-icon"></span>
              <span style="color:#FD5000;">${item}</span>
            `
            // 在第 2 个子元素前 追加
            const secondElement = couponRulesTipDOM.querySelector('ol').children[index + 1]
            secondElement.parentNode.insertBefore(li, secondElement)
          })
        } else {
          usageDesc.forEach(item => {
            const li = document.createElement('li')
            li.className = 'usage-desc-li'
            li.innerHTML = `
              <span class="item-icon"></span>
              <span>${item}</span>
            `

            // 向后追加
            couponRulesTipDOM.querySelector('ol').appendChild(li)
          })
        }
      }

      // 更新定位
      couponRulesTipDOM.style.display = 'block'
      const offsetLeft = e.target.offsetLeft
      const offsetTop = e.target.offsetTop

      const { width, height, } = couponRulesTipDOM.getBoundingClientRect()

      const top = offsetTop - scrollTop - (height / 2) + 7

      couponRulesTipDOM.style.left = offsetLeft - width - 20 + 'px'
      couponRulesTipDOM.style.top = (top >= 0 ? top : 0) + 'px'

      couponRulesTipDOM.querySelector('.angle').style.top = top >= 0 ? 'calc(50%)' : `calc(50% + ${top}px)` 
    }

    couponPkgRulesDOMs.forEach(it => {
      // PC
      it.addEventListener('mouseenter', (e) => enterEvent(e, it))
      // Mobile
      it.addEventListener('touchend', (e) => enterEvent(e, it))

      it.addEventListener('mouseleave', (e) => {
        if (it.classList.contains('rule-tip-show')) {
          timer = setTimeout(() => {
            it.classList.remove('rule-tip-show')
            couponRulesTipDOM.style.display = 'none'
          }, 150)
        }
      })
    })

    couponRulesTipDOM.addEventListener('mouseover', () => {
      clearTimeout(timer)
    })
    couponRulesTipDOM.addEventListener('mouseleave', (e) => {
      timer = setTimeout(() => {
        couponPkgRulesDOMs.forEach(it => it.classList.remove('rule-tip-show'))
        e.target.style.display = 'none'
      }, 150)
    })
  }

  // 处理 券码包 更多文案
  handleMoreText(text) {
    const allText = text.filter(it => it !== '').reduce((p, n) => p += `${n}\n`, '')

    // 最多显示 150 个字符
    const MAX_TEXT = isMobile() ? 125 : 170

    const couponPkgMoreTextDOM = document.querySelector('[data-coupon-pkg-more-text]')
    const couponPkgMoreBtn = document.querySelector('[data-coupon-pkg-more-btn]')

    if (allText.length > MAX_TEXT) {
      couponPkgMoreTextDOM.innerHTML = `${allText.substr(0, MAX_TEXT).replaceAll('\n', '<br/>')}...`
      couponPkgMoreBtn.style.display = 'inline-block'
    } else {
      couponPkgMoreTextDOM.innerHTML = allText.replaceAll('\n', '<br/>')
      couponPkgMoreBtn.style.display = 'none'
    }

    // Mobile
    if (isMobile() && window.screen.width <= 768) {
      couponPkgMoreBtn.addEventListener('click', e => {
        const target = e.target.tagName === 'I' ? e.target.parentElement : e.target
        const { more, retract } = target.dataset
        if (!target.classList.contains('retract')) {
          target.classList.add('retract')
          target.innerHTML = `${retract} <i data-retract-arrow></i>`

          couponPkgMoreTextDOM.innerHTML = allText.substr(0, allText.length - 1).replaceAll('\n', '<br/>')
          this.couponPkgListWrapDOM.style.height = '46.9333333333333vw'
        } else {
          target.classList.remove('retract')
          target.innerHTML = `${more} <i data-more-arrow></i>`

          couponPkgMoreTextDOM.innerHTML = `${allText.substr(0, MAX_TEXT).replaceAll('\n', '<br/>')}...`
          this.couponPkgListWrapDOM.style.height = '77.33333333vw'
        }
      })
    }
    // PC
    else {
      couponPkgMoreBtn.addEventListener('mouseover', e => {
        const div = document.createElement('div')
        div.className = 'coupon-pkg-more-text-all'
        div.innerHTML = allText.substr(0, allText.length - 1).replaceAll('\n', '<br/>')
        if (!this.couponPkgWrapDOM.querySelector('.coupon-pkg-more-text-all')) {
          this.couponPkgWrapDOM.appendChild(div)
        }

        document.querySelector('.coupon-pkg-more-text-all').addEventListener('mouseleave', e => {
          this.couponPkgWrapDOM.removeChild(e.target)
        })
      })
    }
  }
}

// 新人插件
export default NewCustomerPop
